export default {
    detail: '/MedicalCollege/operation/replay/detail',
    queryShareConfig: '/MedicalCollege/operation/replay/queryShareConfig',
    menuList: '/MedicalCollege/operation/replay/menuList',
    selectOperationDoctor: '/MedicalCollege/operation/replay/selectOperationDoctor',
    lesson: '/MedicalCollege/operation/lesson',
    queryShareConfig: '/MedicalCollege/operation/replay/queryShareConfig'
}